import React from "react"
import PropTypes from "prop-types"
import Tag from "@irati/ui/src/Tag"

import "./styles/Tags.css"

const Tags = ({data, handleTagClick, selected}) => {
  return (
    <div className="categoryTagsTags">
      {data.map((tag) => {
        return <Tag tag name={tag.name} selected={selected.indexOf(tag) > -1} onClick={() => handleTagClick(tag)} key={tag.name} />
      })}
    </div>
  )
}

Tags.propTypes = {
  data: PropTypes.array,
  handleTagClick: PropTypes.func,
  selected: PropTypes.array
}

Tags.defaultProps = {
  data: [],
  handleTagClick: () => {},
  selected: []
}

export default Tags
